/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */

/**
 * 布局组件
 */
import Footer from './Footer';
import { ChatbotAction } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export { AvatarDropdown, AvatarName, Footer, ChatbotAction };

/**
 * 通用组件
 */
import DynamicBattery from './Battery';
import Card3D from './Card3D';
import FlvPlayer from './FlvPlayer';
import IconFont from './IconFont';

export { IconFont, DynamicBattery, Card3D, FlvPlayer };

/**
 * 业务组件
 */
import Chatbot from './Chatbot';
import RobotHeader from './RobotHeader';
import RobotStatusCard from './RobotStatusCard';

export { Chatbot, RobotHeader, RobotStatusCard };
